<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> 历史数据
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div class="search-container">
            <div class="search-content">
                <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="handle-select mr10" style="width:300px;"></el-date-picker>
                <el-select v-model="query.balanceId" placeholder="秤" class="handle-select mr10" @change="handleBalanceChange">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <div class="table-wrapper">
            <div class="table-container" @scroll="handleScroll" ref="tableContainer">
                <el-table :data="frequencys" border class="table" ref="multipleTable" element-loading-text="玩命加载中..." v-loading="loading" header-cell-class-name="table-header">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column sortable prop="modifyDate" label="操作时间" width="150">
                        <template slot-scope="scope">
                            <i class="el-icon-time"></i>
                            {{ scope.row.date | formateData }}
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="balanceId" label="秤号"></el-table-column>
                    <el-table-column sortable prop="balanceName" label="秤名"></el-table-column>
                    <el-table-column prop="frequency" label="班次"></el-table-column>
                    <el-table-column prop="speed" label="速度(m/s)"></el-table-column>
                    <el-table-column prop="flow" label="流量(t/h)"></el-table-column>
                    <el-table-column prop="weight" label="重量(t)"></el-table-column>
                    <el-table-column prop="totalWeight" label="总重量(t)"></el-table-column>
                </el-table>
                <!-- 加载更多提示 -->
                <div v-if="loadingMore" class="loading-more">正在加载更多...</div>
                <div v-else-if="!hasMoreData && frequencys.length > 0" class="loading-more">没有更多数据了</div>
            </div>
        </div>
        <!-- <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div> -->
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField
} from '../../utils/helper';
let that;
export default {
    name: 'frequency',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            balanceArr: [],
            frequencys: [],
            pageCount: 1,
            multipleSelection: [],
            loading: false,
            isDisplayCompanyName: false,
            loadingMore: false,
            hasMoreData: true,
            // 防抖相关
            debounceTimer: null,
            // 增加一个标志，防止在加载过程中重复触发
            isLoadingMore: false,
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                daterange: '',
                balanceId: 0,
                PageIndex: 1,
                PageSize: 100
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        const end = new Date();
        const start = new Date();
        // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        start.setTime(start.getTime() - 3600 * 1000);
        this.query.daterange = [start, end];

        this.getData();
        this.getBalance();
    },

    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning('日期不能为空!!!');
                return Promise.resolve();
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.query.CreateUserId = userInfo.id;
            this.query.UserName = userInfo.realName;
            
            // 如果是第一页，则重置数据和状态
            if (this.query.PageIndex === 1) {
                this.frequencys = [];
                this.hasMoreData = true;
            }
            
            return this.$zybhttp
                .post('DataInquiry/GetHisList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('id', 'desc'));
                        
                        // 如果是第一页，直接替换数据，否则追加数据
                        if (this.query.PageIndex === 1) {
                            this.frequencys = newdata;
                        } else {
                            this.frequencys = [...this.frequencys, ...newdata];
                        }
                        
                        this.pageCount = res.data.total || 0;
                        
                        // 如果返回的数据量小于页大小，说明没有更多数据了
                        if (newdata.length < this.query.PageSize) {
                            this.hasMoreData = false;
                        }
                    } else {
                        this.$notify.error(res.message);
                        // 如果加载更多失败，恢复页码
                        if (this.query.PageIndex > 1) {
                            this.query.PageIndex--;
                        }
                    }
                })
                .catch((err) => {
                    this.$notify.error('网络异常！获取列表失败！');
                    // 如果加载更多失败，恢复页码
                    if (this.query.PageIndex > 1) {
                        this.query.PageIndex--;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingMore = false;
                    this.isLoadingMore = false;
                });
        },

        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            var serach = {};
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 =="是" ? true : false;
                        this.balanceArr = [{
                            id: 0,
                            name: '全部',
                            fullName: '全部',
                        }].concat(d).sort(SortField('id', 'asc'));
                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },

        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },

        indexMethod(index) {
            return index + 1;
        },

        // 搜索按钮点击事件
        handleSearch() {
            // 重置页码为第一页
            this.query.PageIndex = 1;
            // 调用数据加载方法
            this.getData();
        },

        // 秤选择器变化事件
        handleBalanceChange() {
            // 重置页码为第一页
            this.query.PageIndex = 1;
            // 调用数据加载方法
            this.getData();
        },

        // 滚动事件处理 - 增加防抖
        handleScroll(event) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            
            // 设置新的定时器，500ms后执行加载检查
            this.debounceTimer = setTimeout(() => {
                const container = event.target;
                // 调整触发条件：距离底部20px时触发，减少触发频率
                if (container.scrollTop + container.clientHeight >= container.scrollHeight - 20) {
                    this.loadMoreData();
                }
            }, 2000);
        },

        // 加载更多数据
        loadMoreData() {
            // 增加更多的防重复加载检查
            if (this.loadingMore || this.loading || !this.hasMoreData || this.isLoadingMore) {
                return;
            }
            
            this.loadingMore = true;
            this.isLoadingMore = true;
            // 增加页码
            this.query.PageIndex++;
            // 请求下一页数据
            this.getData().finally(() => {
                // 确保无论请求结果如何，都重置加载状态
                this.loadingMore = false;
                this.isLoadingMore = false;
            });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.search-container {
    margin-bottom: 15px;
    width: 100%;
}

.search-content {
    text-align: right; /* 靠右对齐 */
}

.handle-headright {
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.table-wrapper {
    width: 100%;
    height: 600px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 20px;
}

.table-container {
    height: 100%;
    overflow-y: scroll;
    width: 100%;
    display: block;
    box-sizing: border-box;
    /* 确保滚动条始终显示 */
    scrollbar-width: auto;
    scrollbar-color: #888 #f1f1f1;
}

/* Webkit浏览器自定义滚动条 - 增加宽度使其更明显 */
.table-container::-webkit-scrollbar {
    width: 12px;
    background-color: #f1f1f1;
}

.table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.table-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
    border: 2px solid #f1f1f1;
}

.table-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* 确保表格宽度正确 */
.el-table {
    width: 100% !important;
}

.loading-more {
    text-align: center;
    padding: 10px;
    color: #909399;
    background-color: #f5f7fa;
    border-top: 1px solid #ebeef5;
}

.size-full {
    width: 100%;
}

</style>
